 
import React from "react";
import { api } from "../../api/api";
import { CustomFormLabel, CustomShrinkTextField, CustomTextField } from "../formsComponents";
import { Autocomplete, CircularProgress } from "@mui/material";
import { ICustomerAutoSearchProps } from "./AutoCompleteSearches.types";
import { debounce } from "lodash";
import { ICustomerFullDetails } from "../../redux/customer/customer.types";
import axios from "axios";

export const CustomerAutoSearch: React.FC<ICustomerAutoSearchProps> = (
  props
) => {
  const { value, onSelect, label, disabled, placeholder , hasShrinkTextField, shrinkTextFieldSize} = props;
  const [options, setOptions] = React.useState<readonly ICustomerFullDetails[]>(
    []
  );
  const [loading, setLoading] = React.useState(false);
  const [search, setSearchText] = React.useState<any>("");
  const initialLoad = React.useRef(false);
  const cancelTokenSource = React.useRef<any>(null);

  const fetchSuggestion = async (
    value: string,
    isById: boolean,
    cancelToken: any
  ) => {
    setLoading(true);
    try {
      let url = `/customer/get-customer-all-detailed-record`;
      if (isById) {
        url = url + `?customer_id=${value}`;
      } else {
        url =
          url +
          `?column=customer_id&column=customer_code&column=customer_name&value=${value}`;
      }
      const res = await api.get(url, {
        cancelToken: cancelToken,
      });
      const data: ICustomerFullDetails[] = res.data.data;
      setOptions(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const debounceFn = React.useCallback(debounce(fetchSuggestion, 800), []);

  const getOptionLabel = (option: string | ICustomerFullDetails) => {
    if (typeof option === "string") {
      return option;
    }
    return `${option.customer_name || ""} (${option.customer_code})`;
  };
  React.useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();

    if (search && search !== value) {
      debounceFn(search, false, cancelTokenSource.token);
    }
    // Cleanup function to cancel the request when the component unmounts
    return () => {
      cancelTokenSource.cancel("Operation canceled due to component unmount.");
    };
  }, [search]);

  React.useEffect(() => {
    if (value && !initialLoad.current) {
      debounceFn(value, true, null);
    }
  }, [value]);

  return (
    <>
      {label && !hasShrinkTextField && <CustomFormLabel>{label}</CustomFormLabel>}
      <Autocomplete
        id="google-map-demo"
        fullWidth
        sx={{
          ".MuiOutlinedInput-root": {
            paddingTop: "0px",
            paddingBottom: "0px",
           
            color: "rgb(38, 38, 38)",
            width: "100%",
            height: hasShrinkTextField ? "55px" : undefined,
          },
        }}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(option, value) =>
          typeof option === "string"
            ? option === value
            : //@ts-ignore
              option.customer_id === value.customer_id
        }
        filterOptions={(x) => x}
        options={options}
        autoComplete
        includeInputInList
        value={
          options.find((option) => option.customer_id === Number(value)) || null
        } // Set the selected value based on the selectedId
        loading={loading}
        disabled={disabled}
        noOptionsText="Type to search"
        //@ts-ignore
        onChange={(
          event: React.ChangeEvent<HTMLElement>,
          newValue: ICustomerFullDetails | null
        ) => {
          if (newValue) {
            onSelect(newValue);
          } else {
            onSelect({
              activity: "",
              customer_id: "",
              anti_spam_consent: "",
              assigned_to: "",
              branch: "",
              customer_code: "",
              customer_name: "",
              email: "",
              facebook: "",
              first_name: "",
              form_of_business: "",
              goes_by: "",
              insert_ts: "",
              language: "",
              last_name: "",
              linkedin: "",
              mailing_address: "",
              marketer: "",
              mobile: "",
              phone: "",
              phone_ext: "",
              position: "",
              privacy_act_consent: "",
              privacy_consent: "",
              producer: "",
              salutation: "",
              tax_zone: "",
              telematics_consent_code: "",
              website: "",
              city: "",
              country: "",
              postal_code: "",
              province_or_state: "",
            });
          }
        }}
        onInputChange={(event, newInputValue) => {
          if ((event && event.type === "change") || !newInputValue) {
            setSearchText(newInputValue);
            initialLoad.current = true;
          }
        }}
        renderInput={(params) => (
          hasShrinkTextField ? (
            <CustomShrinkTextField
            {...params}
            fullWidth
            placeholder={placeholder}
            label={label}
            size={shrinkTextFieldSize || "medium"}
            error={props.error ? true : false}
            helperText={props.helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
          ): (
            <CustomTextField
            {...params}
            fullWidth
            placeholder={placeholder}
            error={props.error ? true : false}
            helperText={props.helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
          )
          
        )}
      />
    </>
  );
};
